import axios from 'axios'
import { NAO_EMBARCAR_PASSAGEIRO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function naoEmbarcarPassageiro (idEmpresa, idReserva) {
  const url = `${URL}/reserva/empresa/${idEmpresa}/reserva/${idReserva}/nao-embarcar`;
  return dispatch => axios.post(url,null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: NAO_EMBARCAR_PASSAGEIRO,
        payload: response
      })
  );
}
